export const defaultSortFunc = (a, b) => {
  /* 
    When displaying dropdowns list values, we want to display all values alphabetically
    with the exception of "non" values up top and "else" values on bottom
  */
  const PREPEND = ['NONE', 'N_A', ''];
  const APPEND = ['OTHER', 'UNKNOWN'];
  const aValue = a.groupLabel
    ? a.groupLabel
    : isNaN(a.value) || a.value === ''
      ? a.value
      : parseInt(a.value);
  const bValue = b.groupLabel
    ? b.groupLabel
    : isNaN(b.value) || b.value === ''
      ? b.value
      : parseInt(b.value);

  if (PREPEND.indexOf(aValue) > PREPEND.indexOf(bValue)) return -1;
  if (PREPEND.indexOf(aValue) < PREPEND.indexOf(bValue)) return 1;
  if (APPEND.indexOf(aValue) > APPEND.indexOf(bValue)) return 1;
  if (APPEND.indexOf(aValue) < APPEND.indexOf(bValue)) return -1;

  return aValue > bValue ? 1 : -1;
};
